import ToggleButton from "../../../../../src/components/ui/togglebutton/ToggleButton";

interface ReportToggleSectionProps {
  label: string;
  isOn: boolean;
  onToggle: () => void;
  children?: React.ReactNode;
  showDivider?: boolean;
  disabled?:boolean;
}

const ReportToggleSection: React.FC<ReportToggleSectionProps> = ({
  label,
  isOn,
  onToggle,
  children,
  showDivider = true,
  disabled=false,
}) => {
  return (
    <div className="flex flex-col">
      {/* Header row */}
      <div className="flex w-[352px] py-[6px] px-0 items-start gap-4">
        <span className="text-sm font-semibold leading-5 text-[#737373] font-sans">
          {label}
        </span>

        <ToggleButton isOn={isOn} onToggle={onToggle} disabled={disabled}/>
      </div>

      {/* Expandable content */}
      {isOn && children && (
        <div className="pl-0">
          {children}
        </div>
      )}

      {showDivider && (
        <div className="pt-7 pb-7 px-1">
          <div className="h-px w-full bg-[#E5E5E5]" />
        </div>
      )}
    </div>
  );
};

export default ReportToggleSection;